/**
 * @required ISO 639-1
 * @see https://ko.wikipedia.org/wiki/ISO_639-1_%EC%BD%94%EB%93%9C_%EB%AA%A9%EB%A1%9D
 */
export type LocaleLanguage =
  | 'ko' // 한국어
  | 'en' // 영어
  | 'vi' // 베트남어
  | 'pl' // 폴란드어
  | 'de' // 독일어
  | 'id' // 인도네시아어
  | 'ja' // 일본어
  | 'th' // 태국어
  | 'es' // 스페인어
  | 'zh-CN' // 중국어(번체)
  | 'zh-TW'; // 중국어(간체)

/**
 * @required ISO 3166-1
 * @see https://ko.wikipedia.org/wiki/ISO_3166-1
 */
export type LocaleRegions =
  | 'KR' // 한국
  | 'US' // 미국
  | 'VN' // 베트남
  | 'PL' // 폴란드
  | 'DE' // 독일
  | 'ID' // 인도네시아
  | 'JP' // 일본
  | 'TH' // 태국
  | 'ES' // 스페인
  | 'CN' // 중국
  | 'TW'; // 타이완(대만)

export const LOCALE_LANGUAGES: LocaleLanguage[] = [
  'ko', // 한국어
  'en', // 영어
  'vi', // 베트남어
  'pl', // 폴란드어
  'de', // 독일어
  'id', // 인도네시아어
  'ja', // 일본어
  'th', // 태국어
  'es', // 스페인어
  'zh-CN', // 중국 본토, 간체
  'zh-TW', // 대만, 번체
];

export const LOCALE_REGIONS: LocaleRegions[] = [
  'KR', // 한국
  'US', // 미국
  'VN', // 베트남
  'PL', // 폴란드
  'DE', // 독일
  'ID', // 인도네시아
  'JP', // 일본
  'TH', // 태국
  'ES', // 스페인
  'CN', // 중국
  'TW', // 타이완(대만)
];

export const LOCALES: string[] = [
  'ko-KR',
  'en-US',
  'vi-VN',
  'pl-PL',
  'id-ID',
  'ja-JP',
  'th-TH',
  'es-ES',
  'zh-CN',
  'zh-TW',
];
